export default __webpack_public_path__ + "static/media/sugarsnap.1508fa00.svg";